import React from 'react'
import BuyButtonContainer, {
  BuyButtonContainerProps,
} from '../BuyComponent/BuyButtonContainer'
import { useToast } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'
import { WithRouterProps } from 'react-router'
import { withRouter } from '@/checkout-instore-legacy/utils/withRouter'
import {
  sendMetric,
  MetricAction,
  MetricShowcase,
} from '@/checkout-instore-legacy/VtexLakeHouse'

export type AddToCartButton = BuyButtonContainerProps

export const AddToCartButton = withRouter(
  ({
    beforeAddToCart = () => {},
    router,
    ...props
  }: // TODO: this error popped up when moving the checkout-instore project
  // to checkout-instore-legacy, but needs to be fixed at some point
  // @ts-ignore
  BuyButtonContainerProps & WithRouterProps) => {
    const showToast = useToast()

    const handleShowCartAnchorClick = () => {
      sendMetric({
        action: MetricAction.QuickAddShowCart,
        showcase: MetricShowcase.QuickAdd,
      })
      router.push('/cart')
    }

    const handleBeforeAddToCart = () => {
      showToast({
        variant: 'positive',
        duration: 5000,
        message: <FormattedMessage id="product.add-to-cart-toast-message" />,
        action: {
          label: (<FormattedMessage id="product.show-cart-message" />) as any,
          onClick: handleShowCartAnchorClick,
        },
        dismissible: true,
      })

      sendMetric({
        action: MetricAction.QuickAddAddToCart,
        showcase: MetricShowcase.QuickAdd,
      })

      beforeAddToCart()
    }

    return (
      <BuyButtonContainer
        variant="secondary"
        beforeAddToCart={handleBeforeAddToCart}
        {...props}
      >
        <FormattedMessage id="addToCartFooterLabel" />
      </BuyButtonContainer>
    )
  }
)
